export default __webpack_public_path__ + "static/media/infection.b632d477.svg";